// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Pa5DR","productName":"Table_productName__uxffP"};